import { OutletTiming } from "@app/shared/models/api-response/outlet-timing-response";

export class OutletOpeningTiming {
    openingTime: string;

    constructor(outlet_timing: OutletTiming) {
        this.openingTime = this._getSob(outlet_timing);
    }

    private _getSob(outlet_timing: OutletTiming): string {
        const date = new Date(outlet_timing.sob_time);
        return 'Opens at ' + date.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit' });
    }
}